
document.addEventListener("DOMContentLoaded", function () {
    document.querySelectorAll(".toggle-nav-wrapper").forEach(link => {
        link.addEventListener("click", function (e) {
            document.querySelector(".navigation-menu").classList.toggle("active");

        });
    });
    document.querySelectorAll(".menu-item-has-children a i").forEach(link => {
        link.addEventListener("click", function (e) {
            e.preventDefault(); // Prevent default link behavior
            const parent = this.closest(".menu-item-has-children");
            console.log(parent)
            // if (e.target.tagName === "i" || e.target.tagName === "svg") {
            //     alert()
                parent.classList.toggle("active");
                
            // }
        });
    });
});